import { useTranslation } from "react-i18next";
import { Button, Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { deleteEquipmentParts, getEquipmentPartCopySpecsByQuery, getEquipmentPartsByQuery, getEquipmentPartsSpecOnlyById, patchEquipmentPartsSpec, postEquipmentParts } from "components/axios/equipmentAxios";
import { getEquipmentCategoriesByQuery, getMasterEquipmentPartsByQuery } from "components/axios/equipmentCategoryAxios";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import { useEffect } from "react";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import EquipmentListLayer from "components/layer/EquipmentListLayer";
import MainCard from "components/MainCard";
import AvgLifeTime from "components/AvgLifeTime";
import { getSensorsByQuery } from "components/axios/iotAxios";
import dayjs from "dayjs";
import moment from "moment";
import CustomDatePicker from "components/date_picker/CustomDatePicker";
import CustomFormIotSelect from "components/select/CustomFormIotSelect";

// const EquipmentSpec = ({info, equipmentPartAllList}) => {
const EquipmentSpec = ({info}) => {
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');
    
    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
            },
            message: alertMessage,
        });
    };

    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const [equipmentCategoryComponentId, setEquipmentCategoryComponentId] = useState(0);
    const [equipmentCategoryComponents, setEquipmentCategoryComponents] = useState(null);
    const [equipmentCategoryComponentsSelected, setEquipmentCategoryComponentsSelected] = useState([]);

    const [equipmentCategoryPosition, setEquipmentCategoryPosition] = useState('');
    const [equipmentCategoryPositions, setEquipmentCategoryPositions] = useState(null);
    const [equipmentCategoryPositionsSelected, setEquipmentCategoryPositionsSelected] = useState([]);

    const [masterEquipmentParts, setMasterEquipmentParts] = useState(null);
    const [masterEquipmentPartSelectBoxs, setMasterEquipmentPartSelectBoxs] = useState(null);

    const [equipmentPartId, setEquipmentPartId] = useState(0);
    const [equipmentParts, setEquipmentParts] = useState(null);
    const [equipmentPartsSelected, setEquipmentPartsSelected] = useState([]);

    const [equipmentSpecs, setEquipmentSpecs] = useState([]);

    const {control: partControl, register: partRegister, handleSubmit: partHandleSubmit, reset: partReset
        , setValue: partSetValue, formState : {isDirty: partIsDirty, errors: partErrors } } = useForm({});
    const [isLoading, setIsLoading] = useState(false);

    const { register : specUpdateRegister, handleSubmit : specUpdateHandleSubmit, reset : specUpdateReset
        , setValue: specSetUpdateValue, formState : {isDirty : specUpdateIsDirty, errors : specUpdateErrors } } = useForm({});

    const toDate = new Date();

    // 설비구성부 목록
    const equipmentCategoryComponentList = async() => {
        const param = { "parent.id": info.equipmentCtgr.id, depth: 4, size : 100, sort : "name,asc" };
        await getEquipmentCategoriesByQuery(param).then((data) => {
            if (data && data._embedded) {
            const list = data._embedded.equipmentCategories;
            if (list) {
                setEquipmentCategoryComponents(list);
            } else {
                setEquipmentCategoryComponents(null);
            }
            } else {
            setEquipmentCategoryComponents(null);
            }
        });
    };

    // 설비구성부 선택
    const selectEquipmentCategoryComponent = (i, data) => {
        // console.log(data)
        setEquipmentCategoryComponentId(data.id);
        setEquipmentSpecs([]);
        specSetUpdateValue('specLength',0);
        setEquipmentPartId(0);
        let copy = [...equipmentCategoryComponentsSelected];
        copy = Array.from({ length: copy.length }, () => null);
        copy[i] = "bold";
        setEquipmentCategoryComponentsSelected(copy);
        partSetValue("masterEquipmentPartId", '');
        partSetValue("lifeSpanTime", '');
    };

    useEffect(()=>{
        equipmentPartList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[equipmentCategoryComponentId, equipmentCategoryPosition]);

    useEffect(()=>{
        masterEquipmentPartList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[equipmentCategoryComponentId]);

    // 자재 목록
    const masterEquipmentPartList = async() => {
        const param = { "equipmentCtgr.id": equipmentCategoryComponentId, size:100 };
        await getMasterEquipmentPartsByQuery(param).then((data) => {
            if (data && data._embedded) {
                const list = data._embedded.masterEquipmentParts;
                if (list) {
                    setMasterEquipmentParts(list);
                    let selectBoxList = [];
                    let selectBox ;
                    list.map((part)=>{
                        selectBox = {id:part.id, sn:part.name, name:part.code}
                        selectBoxList.push(selectBox);
                    })
                    setMasterEquipmentPartSelectBoxs(selectBoxList);
                } else {
                    setMasterEquipmentParts(null);
                    setMasterEquipmentPartSelectBoxs(null);
                }
            } else {
                setMasterEquipmentParts(null);
                setMasterEquipmentPartSelectBoxs(null);
            }
        });
    };

    // 설비구성부위치 선택
    const selectEquipmentCategoryPosition = (i, data) => {
        setEquipmentCategoryPosition(data);
        let copy = [...equipmentCategoryPositionsSelected];
        copy = Array.from({ length: copy.length }, () => null);
        copy[i] = "bold";
        setEquipmentCategoryPositionsSelected(copy);

        setEquipmentPartId(0);
        let copy2 = [...equipmentPartsSelected];
        copy2 = Array.from({ length: copy2.length }, () => null);
        setEquipmentPartsSelected(copy2);
        setEquipmentSpecs([]);
        specSetUpdateValue('specLength',0);
    };

    // 설비에 등록된 자재목록
    const equipmentPartList = async()=> {
        if (equipmentCategoryComponentId && equipmentCategoryPosition) {
            const param = {size:50, "equipment.id": info.id, "masterEquipmentPart.equipmentCtgr.id": equipmentCategoryComponentId, position: equipmentCategoryPosition, deletedYn:false};
            await getEquipmentPartsByQuery(param).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentParts;
                    if (list) {
                        setEquipmentParts(list);
                    } else {
                        setEquipmentParts(null);
                    }
                } else {
                    setEquipmentParts(null);
                }
            });
        }
    }

    const selectMasterEquipmentParts = (e) => {
        const selectedId = e.target.value;
        const data = masterEquipmentParts.find(item => item.id === selectedId);
        partSetValue("lifeSpanTime", (data.lifeSpanTime/24/30));
    }

    // 설비에 등록된 자재 선택
    const selectEquipmentPart = async(i, data) => {
        setEquipmentPartId(data.id);
        setEquipmentSpecs([]);
        specSetUpdateValue('specLength',0);
        await getEquipmentPartsSpecOnlyById(data.id).then((resData)=>{
            console.log(resData);
            if (resData) {
                let specs = [];
                if (resData.masterEquipmentPart && resData.masterEquipmentPart.specKeys) {
                    resData.masterEquipmentPart.specKeys.map((msp, idx)=>{
                        let specValue = resData.specs.find(sp => sp.specKey.id === msp.id);
                        specs.push({"key":msp,"value":{"id":specValue?.specValue?.id||null, "value":specValue?.specValue?.value||null}});

                        specSetUpdateValue('specKeyId'+idx, msp.id);
                        specSetUpdateValue('specValueId'+idx, specValue?.specValue?.id||null);
                        specSetUpdateValue('specValueUpdate'+idx, specValue?.specValue?.value||null);
                    })
                }
                console.log(specs)
                setEquipmentSpecs(specs);
                specSetUpdateValue('specLength',specs.length);
            } else {
                setEquipmentSpecs([]);
                specSetUpdateValue('specLength',0);
            }
        })
        
        let copy = [...equipmentPartsSelected];
        copy = Array.from({ length: copy.length }, () => null);
        copy[i] = "bold";
        setEquipmentPartsSelected(copy);
    };

    useEffect(()=>{
        if (info && info.equipmentCtgr && !isLoading) {
            if (info.equipmentCtgr && info.equipmentCtgr.id)
                equipmentCategoryComponentList();
            if (info.equipmentCtgr && info.equipmentCtgr.positions)
                setEquipmentCategoryPositions(info.equipmentCtgr.positions);
            
            setIsLoading(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[info, isLoading]);

    // 자재-관리주기-설치일 추가
    const onSubmit = (data, e) => {
        e.preventDefault();

        const masterEquipmentPartId = data.masterEquipmentPartId;
        let lifeSpanTime = data.lifeSpanTime;
        lifeSpanTime = (lifeSpanTime*30*24);

        if (data.instlAt == null || data.instlAt == '') {
            alertMessage = t('message.common.alert.installation.date.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        if (data.instlAt != null && data.instlAt != '' && !regexDate.test(data.instlAt)) {
            alertMessage = t('message.common.alert.installation.date.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        let body = {
            equipment : {
                id: info.id
            },
            masterEquipmentPart: {
                id: masterEquipmentPartId
            },
            position: equipmentCategoryPosition,
            lifeSpanTime: lifeSpanTime,
            instlAt : moment(new Date(parseInt((data.instlAt.split("-"))[0]), parseInt((data.instlAt.split("-"))[1]) - 1, parseInt((data.instlAt.split("-"))[2]), 0, 0, 0)).format()
        };

        let selectParam = {
            "equipment.id":info.id,
            "masterEquipmentPart.id":masterEquipmentPartId,
            "position":equipmentCategoryPosition,
            "deletedYn":false
        };
        
        getEquipmentPartsByQuery(selectParam).then((res)=>{
            if (res && res._embedded && res._embedded.equipmentParts) {
                alertMessage = t('message.common.alert.already.registration.material');
                setAlertMessage(alertMessage);
                handleAlertClick();
                return;
            } else {
                openModal(modals.confirmModal, {
                    onSubmit : (value) => {
                        postEquipmentParts(body).then((res)=>{
                            console.log(res)
                            alertMessage = t('message.common.alert.add');
                            setAlertMessage(alertMessage);
                            handleAlertClick();
                            setTimeout(() => equipmentPartList(), 1000);
                            // equipmentPartAllList();
                        }).catch((err) => {
                            console.log(err);
                            if (!err.response?.data?.message) {
                                alertMessage = err.message;
                                setAlertMessage(alertMessage);
                                handleAlertClick();
                            } else if (err.response.data.message) {
                                alertMessage = err.response.data.message;
                                setAlertMessage(alertMessage);
                                handleAlertClick();
                            }
                        });
                        //partReset();
                    },
                    onClose : () => {
                        console.log('close');
                    },
                    message: t('message.common.alert.add.question'),
                });
            }
        })
    }

    // 자재-관리주기-설치일 삭제
    const handlePartDeleteBtnClick = (param)=>{
        getSensorsByQuery({"equipmentPart.id":param}).then((data)=>{
            const isExist = data?.page?.totalElements > 0
            return isExist;
        }).then((res)=>{
            let message = '';
            if (res) {
                message = t('message.common.alert.material.delete.question');
            } else {
                message = t('message.common.alert.delete.question');
            }

            openModal(modals.confirmModal, {
                onSubmit: (value) => {
                    deleteEquipmentParts(param).then((res) => {
                        setTimeout(() => equipmentPartList(), 1000);
                        // equipmentPartAllList();
                    }).catch((err) => {
                        console.log(err);
                        if (!err.response?.data?.message) {
                            alertMessage = err.message;
                            setAlertMessage(alertMessage);
                            handleAlertClick();
                        } else if (err.response.data.message) {
                            alertMessage = err.response.data.message;
                            setAlertMessage(alertMessage);
                            handleAlertClick();
                        }
                    });
                    partReset();
                },
                onClose: () => {
                    console.log('close');
                },
                message: message,
            });
        })
    }
    
    // 스펙 수정
    let onSubmitSpecUpdate = (data, e) => {
        e.preventDefault();
        
        let body = {
            id: equipmentPartId
        };
// console.log(data)
        body.specValues = [];
        for (var i=0 ; i < data.specLength ; i++) {
            body.specValues.push({
                id : eval('data.specValueId'+i),
                key : {id:eval('data.specKeyId'+i)},
                value : eval('data.specValueUpdate'+i)
            })
        }
        // console.log(body)

        openModal(modals.confirmModal, {
            onSubmit : (value) => {
                patchEquipmentPartsSpec(body).then((res)=>{
                    const idx = equipmentParts.findIndex(item => item.id === equipmentPartId);
                    const data = equipmentParts.find(item => item.id === equipmentPartId);
                    // console.log(idx, data);
                    selectEquipmentPart(idx, data);
                    alertMessage = t('message.common.alert.modify.done');
                    setAlertMessage(alertMessage);
                    handleAlertClick();
                }).catch((err)=>{
                    console.log(err);
                    if (!err.response?.data?.message) {
                        alertMessage = err.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    } else if (err.response.data.message) {
                        alertMessage = err.response.data.message;
                        setAlertMessage(alertMessage);
                        handleAlertClick();
                    }
                });
            },
            onClose : () => {
                // console.log('close');
            },
            message: t('message.common.alert.modify.question'),
        });
    };

    // 가져오기
    const changeEquipment = (eId)=> {
        if (eId !== info.id) {
            const body = {
                from : eId,
                to : info.id
            }
            getEquipmentPartCopySpecsByQuery(body).then((res)=>{
                // console.log(res)
                setTimeout(() => equipmentPartList(), 1000);
            })
            // Promise.all([
            //     getEquipmentPartsByQuery({"equipment.id": info.id, deletedYn:false, size:50}).then((data) => {
            //         if (data && data._embedded) {
            //             const list = data._embedded.equipmentParts;
            //             if (list) {
            //                 return list;
            //             }
            //         }
            //         return null;
            //     })
            //     ,
            //     getEquipmentPartsAndSpecByQuery({"equipment.id": eId, deletedYn:false, size:50}).then((data) => {
            //         if (data && data._embedded) {
            //             const list = data._embedded.equipmentParts;
            //             if (list) {
            //                 return list;
            //             }
            //         }
            //         return null;
            //     })
            // ]).then((res)=>{
            //     if (res[0]) {
            //         for (var oldEquip of res[0]) {   // 현재 등록되어 있는 스펙 지우기
            //             deleteEquipmentParts(oldEquip.id);
            //         }
            //     }
            //     if (res[1]) {
            //         for (let equip of res[1]) {   // 새로 등록할 스펙 등록하기
            //             const newEquip = { ...equip }; 
            //             let body = {
            //                 equipment : {
            //                     id: info.id
            //                 },
            //                 masterEquipmentPart: {
            //                     id: newEquip.masterEquipmentPart.id
            //                 },
            //                 position: newEquip.position,
            //                 lifeSpanTime: newEquip.lifeSpanTime,
            //                 // specs : newEquip.specs,
            //                 instlAt : toDate.toISOString(),
            //             };
            //             console.log(body)
            //             postEquipmentParts(body).then((postRes)=> {
            //                 console.log(postRes)
            //                 if (postRes) {
            //                     let specBody = {
            //                         id: postRes.id,
            //                         specValues: []
            //                     };
            //                     if (newEquip.specs && Array.isArray(newEquip.specs)) {
            //                         for (let i = 0; i < newEquip.specs.length; i++) {
            //                             specBody.specValues.push({
            //                                 key : {id:newEquip.specs[i]?.specKey.id},
            //                                 value : newEquip.specs[i]?.specValue.value
            //                             })
            //                         }
            //                     }
            //                     console.log(specBody)
            //                     patchEquipmentPartsSpec(specBody);
            //                 }
            //             });

            //         }
            //     }
            //     setTimeout(() => equipmentPartList(), 1000);
            //     // equipmentPartAllList();
            // })
        }
    }

    if (info && info.equipmentCtgr && isLoading) {
        return (
            <div style={{marginTop:"10px"}}>
                <MainCard style={{marginTop:"10px"}}>
                    <div style={{marginBottom:"10px"}}>
                        <span className='bullet'><img src={`${process.env.PUBLIC_URL}/img/icon/report.png`} alt='' /></span>&nbsp;
                        <Chip label={t('message.common.chip.equipment.spec')} style={{color:"#fff", backgroundColor:"#6a7075", borderRadius:"4px"}} />&nbsp;&nbsp;
                        <EquipmentListLayer excludeId={info.id} equipmentCtgrId={info.equipmentCtgr.id} changeEquipment={changeEquipment} />
                    </div>

                    <div>
                        <div className="scroll_table" style={{alignItems:"flex-start"}}>
                            <TableContainer sx={{width:"28%"}}>
                                <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="th" align="center">{t('message.common.select.component.part')} ({t('message.common.subtitle.category.code')})</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                {equipmentCategoryComponents && equipmentCategoryComponents.map(function(item, i) {
                                    return (
                                    <TableRow key={i}>
                                        <TableCell style={{cursor:"pointer", fontWeight : equipmentCategoryComponentsSelected[i]}} onClick={()=>{
                                            selectEquipmentCategoryComponent(i, item);
                                        }}>{item.name} {(item.code && '('+item.code+')') || ''}</TableCell>
                                    </TableRow>
                                    )
                                })}
                                </TableBody>
                                </Table>
                            </TableContainer>

                            <TableContainer sx={{width:"12%"}}>
                                <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="th" align="center">{t('message.common.select.component.part')} {t('message.common.subtitle.position')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                { equipmentCategoryPositions && equipmentCategoryPositions.map(function(item, i) {
                                    return (
                                    <TableRow key={i}>
                                        <TableCell style={{cursor:"pointer", fontWeight : equipmentCategoryPositionsSelected[i]}} onClick={()=>{
                                            selectEquipmentCategoryPosition(i, item);
                                        }}>{item}</TableCell>
                                    </TableRow>
                                    )
                                })}
                                </TableBody>
                                </Table>
                            </TableContainer>

                            <TableContainer sx={{width:"59%"}}>
                                <form onSubmit={partHandleSubmit(onSubmit)}>
                                <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="th" align="center">{t('message.common.subtitle.material')} ({t('message.common.subtitle.category.code')})</TableCell>
                                        <TableCell className="th" align="center">{t('message.common.subtitle.self')}{t('message.common.subtitle.management.cycle')}</TableCell>
                                        <TableCell className="th" align="center">{t('message.common.subtitle.installation.date')}</TableCell>
                                        <TableCell className="th" align="center">{t('message.common.subtitle.peer.average')}</TableCell>
                                        <TableCell className="th" align="center"></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                { equipmentParts && equipmentParts.map(function(item, i) {
                                    return (
                                    <TableRow key={i}>
                                        <TableCell style={{cursor:"pointer", fontWeight : equipmentPartsSelected[i]}} onClick={()=>{
                                            selectEquipmentPart(i, equipmentParts[i]);
                                        }}>{item.masterEquipmentPart.name} {(item.masterEquipmentPart.code && '('+item.masterEquipmentPart.code+')') || ''}</TableCell>
                                        <TableCell>{item.lifeSpanTime && (item.lifeSpanTime/24/30)}{t('message.common.text.month')}</TableCell>
                                        <TableCell>{dayjs(new Date(item.instlAt)).format("YYYY-MM-DD")}</TableCell>
                                        <TableCell><AvgLifeTime masterEquipmentPartId={item.masterEquipmentPart.id} position={item.position}/></TableCell>
                                        <TableCell>
                                            <Button variant="outlined" color="error" className="small_btn" onClick={()=>{
                                                handlePartDeleteBtnClick(item.id);
                                            }}>{t('message.common.btn.delete')}</Button>
                                        </TableCell>
                                    </TableRow>
                                    )
                                })}
                                </TableBody>
                                {((equipmentCategoryComponentId && equipmentCategoryPosition) || '') &&
                                <tfoot>
                                    <tr>
                                        <td colSpan={2}>
                                            <Controller
                                                sx={{ m: 1, minWidth: "100%" }}
                                                aria-invalid={!partIsDirty ? undefined : partErrors.masterEquipmentPartId ? "true" : "false"}
                                                control={partControl}
                                                name="masterEquipmentPartId"
                                                render={({ field: {name} }) => (
                                                <CustomFormIotSelect
                                                    style={{ minWidth: '90%' }}
                                                    label={t('message.common.subtitle.material')}
                                                    register={partRegister}
                                                    name={name}
                                                    requiredMessage={t('message.common.alert.material.select')}
                                                    defaultValue={''}
                                                    list={masterEquipmentPartSelectBoxs}
                                                    onChange={selectMasterEquipmentParts}
                                                />
                                                )}
                                            />
                                            {partErrors.masterEquipmentPartId && <small role="alert"><br></br>{partErrors.masterEquipmentPartId.message}</small>}
                                        </td>
                                        <td>
                                            <TextField id="outlined-basic" 
                                                aria-invalid={!partIsDirty ? undefined : partErrors.lifeSpanTime ? "true" : "false"}
                                                defaultValue={''}
                                                {...partRegister("lifeSpanTime", {
                                                    required : t('message.common.error.text.self.management.cycle.input')
                                                })} 
                                                sx={{ minWidth: '100%', backgroundColor: "#fff" }} />
                                            {partErrors.lifeSpanTime && <small role="alert"><br></br>{partErrors.lifeSpanTime.message}</small>}
                                        </td>
                                        <td>
                                            <Controller
                                                sx={{ m: 1, minWidth: "100%" }}
                                                aria-invalid={!partIsDirty ? undefined : partErrors.instlAt ? "true" : "false"}
                                                control={partControl}
                                                name="instlAt"
                                                defaultValue={''}
                                                render={({ field: { name, value, ...field }, ref, fieldState }) => (
                                                    <CustomDatePicker 
                                                        sx={{minWidth:"115px"}}
                                                        defaultValue={dayjs(new Date()).format('YYYY-MM-DD')}
                                                        field={field} ref={ref} name={name} value={value} register={partRegister} 
                                                        requiredMessage={t('message.common.alert.installation.date.input')}
                                                        setValue={partSetValue} fieldState={fieldState}
                                                        viewDeleteBtn={false}
                                                    />
                                                )}
                                            />
                                        </td>
                                        <td>
                                            <Button variant="contained" color="primary" className="small_btn" onClick={partHandleSubmit(onSubmit)}>{t('message.common.btn.add')}</Button>
                                        </td>
                                    </tr>
                                </tfoot>
                                }
                                </Table>
                                </form>
                            </TableContainer>
                        </div>
                        <div style={{display:"flex",justifyContent:"flex-end","marginRight":"2px"}}>
                            <TableContainer sx={{width:"59%"}}>
                                <form onSubmit={specUpdateHandleSubmit(onSubmitSpecUpdate)}>
                                <Table aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className="th" align="center" style={{width:"33%"}}>NAME</TableCell>
                                        <TableCell className="th" align="center" style={{width:"42%"}}>KEY</TableCell>
                                        <TableCell className="th" align="center" style={{width:"24%"}}>VALUE</TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                {equipmentSpecs && equipmentSpecs.map(function(con, i) {
                                    // console.log(con)
                                    specSetUpdateValue(`specValueUpdate${i}`, con.value?.value);
                                    return (
                                    <TableRow key={i}>
                                        <TableCell style={{width:"33%"}}>
                                            {con.key.name}
                                        </TableCell>
                                        <TableCell style={{width:"42%"}}>
                                            {con.key.code}
                                        </TableCell>
                                        <TableCell style={{width:"24%"}}>
                                            <TextField id="outlined-basic" 
                                            // aria-invalid={!specUpdateIsDirty ? undefined : eval(`specUpdateErrors.specValueUpdate${i}`) ? "true" : "false"}
                                            {...specUpdateRegister(`specValueUpdate${i}`, {
                                                // required : t('message.common.error.text.value2.input')
                                            })} 
                                            sx={{ minWidth: '100%' }} />
                                            {/* {eval(`specUpdateErrors.specValueUpdate${i}`) && <small role="alert"><br></br>{eval(`specUpdateErrors.specValueUpdate${i}.message`)}</small>} */}
                                        </TableCell>
                                    </TableRow>
                                    );
                                }) }
                                </TableBody>
                                {(equipmentPartId > 0 && equipmentSpecs && equipmentSpecs.length > 0) &&
                                <tfoot>
                                    <tr>
                                        <td colSpan={3} style={{textAlign:"right"}}>
                                            <Button variant="contained" color="success"
                                            onClick={specUpdateHandleSubmit(onSubmitSpecUpdate)}
                                            >{t('message.common.btn.modify')}</Button>
                                        </td>
                                    </tr>
                                </tfoot>
                                }
                                </Table>
                                </form>
                            </TableContainer>
                        </div>
                    </div>
                </MainCard>
            </div>
        )
    }
}
export default EquipmentSpec;